import React from "react";
import Layout from "../core/Layout";

const Admin = () => {
  return (
    <Layout>
      <h1>Admin Page</h1>
    </Layout>
  );
};

export default Admin;
